// Manage active on slider button (dots) controls
// Interacts with existing CSS on `section-main-product.css`
const sliderDotButtonsObserver = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const thumbnailListSelector = ".product--carousel-with-dots .thumbnail-list"
    const activeClassName = "active"
    const thumbnailList = document.querySelector(thumbnailListSelector)
    if (!thumbnailList) return
    const updateActiveClass = () => {
      thumbnailList.querySelectorAll(".thumbnail-list__item").forEach(item => {
        const button = item.querySelector("button")
        item.classList.toggle(activeClassName, button?.getAttribute("aria-current") === "true")
      })
    }
    const observer = new MutationObserver(updateActiveClass)
    const observerOptions = {
      attributes: true,
      attributeFilter: ["aria-current"],
      subtree: true,
    }
    observer.observe(thumbnailList, observerOptions)
    updateActiveClass()
  })
}
sliderDotButtonsObserver()
